<!-- Container -->
<div class="kt-container-fixed">
	Page content
</div>
<!-- End of Container -->